<template>
    <div>
        <modal id="demo-modal" :data="{title:'WELCOME!', body: 'We have some new features we would like to introduce to you.',
                cancel: 'No thanks.', accept: 'Show me!'}" @accept="startTour"></modal>

        <modal id="demo-done" :data="{title:'Need Extra Help?', body:
              'If your see the pulsing dot, click it to get some extra help.', html:
              '<div class=introjs-hint><div class=introjs-hint-dot></div><div class=introjs-hint-pulse></div></div></div>',
              accept: 'Got it!'}"></modal>
    </div>
</template>

<script>

    var introJS = require('intro.js') // necessary for intro stuff
    import "intro.js/minified/introjs.min.css"; //necessary for intro stuff
    import UIkit from 'uikit'; // necessary for intro stuff
    import Modal from './Modal.vue'
    import apiCall from '../../store/apicall.js'

    function confirmWatch(showName, _t){
        apiCall.post('/onboarding/', {'purpose': 'watched_demo', 'parameters':{'page': showName}}).then(function(response) {
            console.log(response)

        })

        delete _t.$store.state.user.data.Demos[_t.showName]
    }

    function initialize(_t, firstShow=true) {
        if (!firstShow){
            _t.intro.hideHints()
            _t.intro._options.hints = []
            _t.intro._options.steps = []
            _t.intro = false;
        }
        if (_t.$store.state.user.data.Demos[_t.showName]) {
            let intro = introJS()
            let steps = [];
            let hints = []
            let demo_data = _t.$store.state.user.data.Demos[_t.showName]
            console.log(_t.showName, demo_data)
            confirmWatch(_t.showName, _t)
            for (var key in demo_data) {
                if (demo_data[key]['include']) {
                    _t.runShow = true;
                    steps.push({
                        element: demo_data[key]['object_id'],
                        intro: demo_data[key]['content'],
                    })
                    hints.push({
                        element: demo_data[key]['object_id'],
                        hint: demo_data[key]['content']
                    })
                }
            }
            if (_t.runShow) {
                setTimeout(function () {
                intro.setOptions({
                    steps: steps,
                    hints: hints,
                    scrollToElement: true
                })
                _t.intro = intro;
                    if (firstShow){
                        UIkit.modal('#demo-modal').show();
                    } else {
                        startTour(_t, false)
                    }
                }, 500)
            }
        }
    }

    function startTour(_t, firstShow=true) {
        if (_t.runShow) {
            _t.$store.dispatch('introStatus', true).then(function(){
                console.log("store state updated to show intro active")
            });
            _t.intro.start()
            _t.intro.oncomplete(function () {
                _t.$store.dispatch('introStatus', false).then(function(){
                    console.log('store state updated to show intro inactive.')
                })
                if (firstShow){
                    // UIkit.modal('#demo-done').show();
                }
                // _t.intro.showHints() // cant figure out why hints arent updating here...
            });
        }
    }

    export default {
        name: "Demo",
        props: ['showName',],
        components: {
            Modal,
        },
        data: function () {
            return {
                runShow: false,
                intro: false
            }
        },
        watch: {
          showName: function() {
              let _t = this;
              if (_t.intro){
                initialize(_t, false);
              } else {
                 initialize(_t, true);
              }

          }
        },
        methods: {
            startTour: function() {
                let _t = this
                startTour(_t);
            }
        },

        mounted() {
            let _t = this
            initialize(_t)
            }
    }

</script>

<style lang="less" scoped>

</style>
